import { render } from "./Friends.vue?vue&type=template&id=f9d7e568&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"

import "./Friends.vue?vue&type=style&index=0&id=f9d7e568&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d7e568"]])

export default __exports__